export const FIELD_NAMES = {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    PHONE: 'phone',
    EMAIL: 'email'
};
